import { Card, Form } from "antd";
import { useTranslation } from "react-i18next";
import { useDownloadContractsVerificationExport } from "../../../../../common/api/queries";
import ActionButton from "../../../../../common/components/buttons/ActionButton";
import { OrderDirection } from "../../../../../common/enums";
import { Permission } from "../../../../../common/security/enums";
import ComponentWithPermission from "../../../../auth/components/ComponentWithPermission";
import { ContractOrderByColumn, ContractView } from "../../../enums";
import { ContractFilterPageRequest } from "../../../types";
import { ContractFilterForm } from "../../forms/ContractFilterForm";

type Props = {
  validatedSearchParams?: ContractFilterPageRequest;
  updateSearchParams: (searchParams: ContractFilterPageRequest, append?: boolean, replace?: boolean) => void;
};

export const ContractListFilterView = ({ validatedSearchParams, updateSearchParams }: Props) => {
  const { t } = useTranslation();

  const [form] = Form.useForm<ContractFilterPageRequest>();

  const downloadContractsVerificationExport = useDownloadContractsVerificationExport();

  const handleFilterClear = () => {
    form.resetFields();
    updateSearchParams(form.getFieldsValue(), false, true);
  };

  return (
    <Card
      className="card-box"
      title={<h2>{t("contract.titles.list")}</h2>}
      extra={
        <>
          <ComponentWithPermission permissions={[Permission.CONTRACT_VERIFICATION_EXPORT]}>
            <ActionButton
              icon="cloud-download"
              color="green"
              variant="outlined"
              size="middle"
              onClick={() => downloadContractsVerificationExport.mutate()}
            >
              {t("contract.actions.verificationExportDownload")}
            </ActionButton>
          </ComponentWithPermission>

          <ActionButton color="danger" size="middle" variant="outlined" icon="reload" onClick={handleFilterClear}>
            {t("common.resetFilter")}
          </ActionButton>
        </>
      }
    >
      <ContractFilterForm
        form={form}
        report={ContractView.INTERNAL_GENERIC_REPORT}
        orderBy={[ContractOrderByColumn.CREATED_AT]}
        orderDirections={[OrderDirection.DESC]}
        updateSearchParams={updateSearchParams}
        validatedSearchParams={validatedSearchParams}
      />
    </Card>
  );
};
